import React from 'react';

import { CoreModal } from 'components/ModalViewV3';
import TextView from 'components/TextView';

import { YbCoreButton } from '@yubi/yb-core-button-v3';

import { ContentStatus } from './ContentTemplate';

interface IModalProps {
  open: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  onPublishHandler: (input: { status: ContentStatus }) => void;
}

const EmptyDataCheckModel = ({
  open,
  onClose,
  onPublishHandler,
}: IModalProps) => {
  return (
    <CoreModal
      open={open}
      onDismiss={() => onClose(false)}
      onModalClose={() => onClose(false)}
    >
      <div className="flex flex-col items-center pt-[36px] gap-4">
        <div className=" flex flex-col items-center gap-2">
          <TextView
            color="#475467"
            weight="400"
            size={14}
            fontStyle="normal"
            lineHeight={20}
            text="Variable mapping is not added. Do you want to publish the content?"
          />
        </div>
        <div className="flex gap-2 px-6 items-center w-full">
          <div className="w-1/2">
            <YbCoreButton
              size="m"
              variant="tertiary"
              label="Cancel"
              onClick={() => onClose(false)}
            />
          </div>
          <div className="w-1/2">
            <YbCoreButton
              size="m"
              variant="primary"
              label="Publish"
              onClick={() => {
                onPublishHandler({ status: ContentStatus.PUBLISHED });
                onClose(false);
              }}
            />
          </div>
        </div>
      </div>
    </CoreModal>
  );
};

export default EmptyDataCheckModel;
